// src/components/BoardPack/components/shared/AiCfoSection.jsx
import React from 'react';

const AiCfoSection = ({
  isCfo = false,
  summary = null,
  cfoComment = "",
  onCfoCommentChange,
  isExporting = false,
  showAiSummary = true,
  showCfoComments = true,
  compact = false,
}) => {
  const hasComment = cfoComment?.trim() !== "";

  // Don't render anything if not CFO or no summary data
  if (!isCfo || !summary?.lines?.length) {
    return null;
  }

  return (
    <div className={compact ? "mt-0.5 flex items-start gap-3 py-1 px-3" : "mt-1 flex items-start gap-4 p-4"}>
      {/* AI Summary Section */}
      {showAiSummary && (
        <div className={compact ? "flex-1 p-1" : "flex-1 p-2"}>
          <div className={compact ? "flex items-center gap-1 mb-1" : "flex items-center gap-2 mb-3"}>
            <div className={compact ? "w-0.5 h-2 bg-blue-600 rounded-full" : "w-1 h-5 bg-blue-600 rounded-full"}></div>
            {/* <h3 className="flex items-start text-sm font-semibold">AI Summary</h3> */}
            <h3 className={compact ? "flex items-start text-[9px] font-semibold whitespace-nowrap" : "flex items-start text-sm font-semibold whitespace-nowrap"}>
  AI Summary
</h3>
          </div>
          {summary?.lines && summary.lines.length > 0 ? (
            <ul className={compact ? "" : "space-y-1"}>
              {summary.lines.map((line, index) => (
                <li key={index} className="flex items-start gap-2">
                  <span className={compact ? "text-[7px] font-medium" : "text-[12px] font-medium"}>
                    {line.replace(/^\s*-\s*/, "")}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-xs text-gray-500">No AI summary available</p>
          )}
        </div>
      )}

      {/* CFO Comments Section */}
      {showCfoComments && (!isExporting || (isExporting && hasComment)) && (
        <div className={compact ? "flex-1 p-1" : "flex-1 p-2"}>
          <div className={compact ? "flex items-center gap-1 mb-1" : "flex items-center gap-2 mb-3"}>
            <div className={compact ? "w-0.5 h-3 bg-blue-600 rounded-full" : "w-1 h-5 bg-blue-600 rounded-full"}></div>
            <h3 className={compact ? "flex items-start text-[10px] font-semibold whitespace-nowrap" : "flex items-start text-sm font-semibold whitespace-nowrap"}>CFO Comments</h3>
          </div>
          {!isExporting ? (
            <textarea
              value={cfoComment}
              onChange={(e) => onCfoCommentChange?.(e.target.value)}
              placeholder="Enter comments here..."
              className={compact ? "w-full h-12 p-1 border border-gray-300 rounded-md text-[9px] resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white" : "w-full h-32 p-3 border border-gray-300 rounded-md text-xs resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"}
            />
          ) : hasComment ? (
            <p className={compact ? "text-[9px] whitespace-pre-wrap break-words" : "text-xs whitespace-pre-wrap break-words"}>{cfoComment}</p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default AiCfoSection;